import React from "react";
import { useCopies } from "shared/hooks/useCopies";
import TicketStatus from "shared/enums/TicketStatus";
import { PurchaseConfirmationPropTypes } from "../../types";
import PurchaseOrderStatus from "shared/enums/PurchaseOrderStatus";
import { InventoryPurchaseTypes, TicketPurchaseTypes } from "../../../enum";

function MessageHeader(props: PurchaseConfirmationPropTypes) {
  const copies = useCopies();
  return (
    <div className="purchaseConfirm_msgHeading">
      <h3 className="purchaseConfirm_msgHeading--title">
        {props.isInvoicePaymentPending ? (
          copies.get("invoice.payment.application.submitted.for.payment")
        ) : (InventoryPurchaseTypes.includes(props.entityType) &&
            props.purchaseOrder?.purchaseOrderStatus === PurchaseOrderStatus.COMPLETED) ||
          // checking `!approvalPending` for ticket upgrade offline payment approval pending case
          (props.ticketStatus === TicketStatus.COMPLETED && !props.approvalPending) ? (
          <React.Fragment>
            {copies.get("congratulations")},
            <strong className="purchaseConfirm_msgHeading--title_username">{props.participantFullName}</strong>
          </React.Fragment>
        ) : (
          [...InventoryPurchaseTypes, ...TicketPurchaseTypes].includes(props.entityType) &&
          props.approvalPending &&
          copies.get("thank.you")
        )}
      </h3>
    </div>
  );
}

export default MessageHeader;
